import { FC, memo } from "react";
import { Box } from "@mui/material";
import { useField, useFormikContext } from "formik";
import OtpInput, { OtpInputProps } from "react18-input-otp";

const OTPInput: FC<{
  name: string;
}> = ({ name }) => {
  const [field] = useField(name);
  const { setFieldValue } = useFormikContext();

  const attributes: OtpInputProps = {
    numInputs: 6,
    id: "otp-input",
    isInputNum: true,
    value: field.value,
    shouldAutoFocus: true,
    className: "otp-input",
    onChange: (value: any) => {
      setFieldValue(name, value, true);
    },
  };

  return (
    <Box className="otp-container">
      <OtpInput {...attributes} />
    </Box>
  );
};

export default memo(OTPInput);
